<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
    <p>{{ data.message }}</p>
    @if (data.preview) {
        <div>
            <img [src]="data.preview" />
        </div>
    }
    @if (data.multiline) {
        <mat-form-field appearance="fill">
            <textarea matInput required [formControl]="input"></textarea>
        </mat-form-field>
    } @else {
        <mat-form-field appearance="fill">
            <input matInput required [formControl]="input" />
        </mat-form-field>
    }
</div>
<div mat-dialog-actions>
    <button mat-button (click)="reject()">Cancel</button>
    <button mat-stroked-button color="primary" (click)="accept()">Ok</button>
</div>
